import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { SpinnerWidth } from "../../gzProgressSpinner/types";
import { FontSizes } from "../../../types/common/types";

export const templateGzCustomTemplateList = document.createElement('template');

templateGzCustomTemplateList.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="content">
      <div class="items"></div>
      <div class="footer">
        <gz-grid-summary></gz-grid-summary>
        <gz-pagination></gz-pagination>
      </div>
    </div>

    <div class="grid-states">
      <div class='loading-container'>
        <gz-progress-spinner spinnerWidth='${SpinnerWidth.LARGE}'></gz-progress-spinner>
      </div>

      <div class="no-results">
          <gz-image-repo state="empty">
            <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight="500" class="no-results--message"></gz-title>
          </gz-image-repo>
          <slot class="no-results-additional-data" name="no-results--additional-data"></slot>
      </div>
    </div>
  </div>
`;
